import React from "react";
import { Navbar } from "react-bootstrap";

function Header() {

  return (
    <Navbar bg="light" expand="lg">
    </Navbar>
  );
}

export default Header;
